import { formatDate } from "../../../components/formatDate";

export const filterData = (dataArray, keys) => {
    return dataArray.map(data =>
      keys.reduce((result, key) => {
        if (data.hasOwnProperty(key)) {
          // Check if the key is userID, and if so, change it to id
          if (key === 'employeeID') {
            result['id'] = data[key]; // Map userID to id
          }else if (key === 'firstName') {
            result['Fullname'] = `${data[key]} ${data.lastName || ''}`.trim(); // Combine firstName and lastName
          }else{
            result[key] = data[key];  // Copy other keys as they are
          }        
        }
        return result;
      }, {})
    );
  };

  export const filterDataOnboarding = (dataArray, keys) => {
    return dataArray.map(data =>
      keys.reduce((result, key) => {
        if (data.hasOwnProperty(key)) {
          // Check if the key is userID, and if so, change it to id
          if (key === 'employeeID') {
            result['id'] = data[key]; // Map userID to id
          }else if (key === 'firstName') {
            result['Fullname'] = `${data[key]} ${data.lastName || ''}`.trim(); // Combine firstName and lastName
          }else if (key === 'phoneNumbers' && Array.isArray(data[key]) && data[key].length > 0) {
            result['phone'] = data[key][0]?.phoneNo ?? null;
          }else {
            result[key] = data[key];  // Copy other keys as they are
          }        
        }
        return result;
      }, {})
    );
  };

  export const filterDataOnboardingInvite = (dataArray, keys) => {
    return dataArray.map(data =>
      keys.reduce((result, key) => {
        if (data.hasOwnProperty(key)) {
          // Check if the key is userID, and if so, change it to id
          if (key === 'employeeID') {
            result['id'] = data[key]; // Map userID to id
          }else if (key === 'firstName') {
            result['Fullname'] = `${data[key]} ${data.lastName || ''}`.trim(); // Combine firstName and lastName
          }else if (key === 'phoneNumbers' && Array.isArray(data[key]) && data[key].length > 0) {
            result['phone'] = data[key][0]?.phoneNo ?? null;
          }else {
            result[key] = data[key];  // Copy other keys as they are
          }        
        }
        return result;
      }, {})
    );
  };